import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as sidebarActions from '../redux/actions/sidebar-actions';
import LocationSidebar from './LocationSidebar';
import StructureSidebar from './StructureSidebar';
import AgendaCalendarSidebar from './AgendaCalendarSidebar';
import NodeAIWorkshop from './NodeAIWorkshop';

const AllSidebarsRoot = () => {
  const dispatch = useDispatch();

  const globalSidebarState = useSelector((state) => state.sidebarReducer);

  return (
    <React.Fragment>
      {globalSidebarState.locationSidebar.show && (
        <LocationSidebar
          {...globalSidebarState.locationSidebar}
          closeSidebar={() =>
            dispatch(
              sidebarActions.locationSidebar({
                show: false,
              })
            )
          }
        />
      )}
      {globalSidebarState.structureSidebar.show && (
        <StructureSidebar
          {...globalSidebarState.structureSidebar}
          closeSidebar={() =>
            dispatch(
              sidebarActions.structureSidebar({
                show: false,
              })
            )
          }
        />
      )}
      {globalSidebarState.editBlockPulseSidebar.show && (
        <StructureSidebar
          {...globalSidebarState.editBlockPulseSidebar}
          closeSidebar={() =>
            dispatch(
              sidebarActions.editBlockPulseSidebar({
                open: false,
              })
            )
          }
        />
      )}
      {globalSidebarState.sidebarAgenda.show && (
        <AgendaCalendarSidebar
          {...globalSidebarState.sidebarAgenda}
          closeSidebar={() =>
            dispatch(
              sidebarActions.sidebarAgenda({
                open: false,
              })
            )
          }
        />
      )}
      {globalSidebarState.sidebarNodeAI.show && (
        <NodeAIWorkshop
          {...globalSidebarState.sidebarNodeAI}
          closeSidebar={() =>
            dispatch(sidebarActions.sidebarNodeAI({ show: false }))
          }
        />
      )}
    </React.Fragment>
  );
};

export default AllSidebarsRoot;
